import styled, { css } from 'styled-components'

export const Value = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    gap: var(--sl-space-1);

    > button {
      padding: 0;
      color: var(--sl-fg-accent);

      svg {
        display: block;
        width: 12px;
        height: 12px;
      }
    }

    > p {
      margin-bottom: initial;
      font-size: 0.875rem;
      font-weight: 500;
      line-height: 17px;
      color: #6f7a83;
    }

    .alert {
      color: ${theme.colors.danger};
      margin-bottom: initial;
    }
  `}
`

type SubtitleSmallProps = {
  isDanger?: boolean
}

export const SubtitleSmall = styled.small<SubtitleSmallProps>`
  ${({ isDanger = true }) => css`
    display: inline-block;
    line-height: 1.25;
    color: ${isDanger ? 'var(--sl-fg-critical)' : 'var(--sl-fg-base-soft)'};
  `}
`

export const FormStack = styled.div`
  display: flex;
  flex-direction: column;
  width: 10rem;
  gap: var(--sl-space-2);
`

export const ButtonCPCDefault = styled.div`
  display: flex;
  width: 100%;
  padding-top: var(--sl-space-2);
  border-top: 1px solid rgb(222, 226, 230);

  .Tooltip__Container,
  .Tooltip__Icon,
  button {
    width: 100%;
  }

  .Badge_UI_Component {
    margin: 0;
  }

  button {
    padding: initial;

    .text {
      white-space: nowrap;
    }

    &:hover {
      text-decoration: underline;
    }
  }
`

export const WrapperInput = styled.div`
  ${({ theme }) => css`
    width: 100%;
    --minWidth: 0;

    > div {
      width: 100%;
      min-width: 0;
    }

    .tooltip-icon {
      color: ${theme.colors.danger};
    }
  `}
`

export const WrapperButtons = styled.div`
  display: flex;
  gap: var(--sl-space-1);

  > button:first-child {
    flex: 0 0 1.75rem;
    width: 1.75rem;
    min-width: 1.75rem;
    padding: 0;

    svg {
      width: 1rem;
      height: 1rem;
      min-width: 1rem;
    }
  }

  > button:last-child {
    flex: 1;
  }
`
